<template>
	<div style="min-height: 70vh; max-height: 100%">
		<vx-card :title="null" class="mt-5" :cardBorder="true" :noShadow="true">
			<div class="vx-row">
				<div class="vx-col w-full flex items-center">
					<feather-icon
						class="g-breadcrumb--title"
						icon="ChevronLeftIcon"
						svgClasses="h-8 w-8"
						@click.prevent="$emit('changeActiveTabEmit', 0)"
					/>
					<vs-breadcrumb
						class="g-breadcrumb--title"
						separator=""
						:items="[{title: $t('general.Return')}]"
						@click.prevent="$emit('changeActiveTabEmit', 0)"
					></vs-breadcrumb>
				</div>
			</div>
			<bread-crumbs
				class="ml-1"
				:title="editable ? $t('Roles.UpdateLabel') : $t('Roles.CreateLabel')"
				:sizeTitle="22"
				:lineHeightTitle="27"
				:sizeSubTitle="13"
				:lineHeightSubTitle="16"
			>
			</bread-crumbs>
			<vs-row vs-w="12">
				<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
					<div class="vx-row mb-6">
						<div class="vx-col w-full md:w-1/3">
							<label class="g-label" v-text="$t('Roles.FormInputRoleName')"></label>
							<vs-input
								class="w-full"
								v-model="role.name"
								name="name"
								:disabled="true"
								v-validate="{required: true, regex: /^[A-Za-z\s_]+$/}"
							/>
							<span
								class="text-danger text-sm"
								v-show="errors.has('name')"
								v-text="$t('Roles.ValidMessages.ValidRoleName')"
							></span>
						</div>
						<div class="vx-col w-full md:w-1/3">
							<label class="g-label" v-text="$t('Roles.FormInputRoleAlias')"></label>
							<vs-input
								class="w-full"
								v-model="role.alias"
								name="name"
								v-validate="{required: true, regex: /^[A-Za-z\s_]+$/}"
							/>
							<span
								class="text-danger text-sm"
								v-show="errors.has('name')"
								v-text="$t('Roles.ValidMessages.ValidRoleName')"
							></span>
						</div>
						<div class="vx-col w-full md:w-1/3">
							<label class="g-label" v-text="$t('Roles.FormInputRoleDescription')"></label>
							<vs-input
								class="w-full"
								v-model="role.description"
								name="description"
								v-validate="{required: true}"
							/>
							<span
								class="text-danger text-sm"
								v-show="errors.has('description')"
								v-text="$t('Roles.ValidMessages.ValidRoleDescription')"
							></span>
						</div>
					</div>
				</vs-col>
			</vs-row>
		</vx-card>
		<vx-card class="mt-base" no-shadow card-border>
			<div class="vx-row">
				<div class="vx-col w-full">
					<div class="flex items-end px-3">
						<feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
						<span class="font-medium text-lg leading-none">{{ $t("Roles.FormInputPermit") }}</span>
					</div>
					<vs-divider />
				</div>
			</div>
			<div class="tableFixHead">
				<table class="w-full">
					<thead>
						<tr>
							<th class="font-semibold text-base text-left px-3 py-6">
								<span> {{ $t(`Crud.Modules`) }} </span>
							</th>
							<th class="font-semibold text-base text-left px-3 py-6">
								<vs-checkbox v-model="checkAllC" :title="$t('SelectAll')" @change="changeCheckAll('C')"
									>{{ $t(`Crud.Create`) }}
								</vs-checkbox>
							</th>
							<th class="font-semibold text-base text-left px-3 py-6">
								<vs-checkbox v-model="checkAllD" :title="$t('SelectAll')" @change="changeCheckAll('D')"
									>{{ $t(`Crud.Delete`) }}
								</vs-checkbox>
							</th>
							<th class="font-semibold text-base text-left px-3 py-6">
								<vs-checkbox v-model="checkAllR" :title="$t('SelectAll')" @change="changeCheckAll('R')"
									>{{ $t(`Crud.Read`) }}
								</vs-checkbox>
							</th>
							<th class="font-semibold text-base text-left px-3 py-6">
								<vs-checkbox v-model="checkAllU" :title="$t('SelectAll')" @change="changeCheckAll('U')"
									>{{ $t(`Crud.Update`) }}
								</vs-checkbox>
							</th>
							<th class="font-semibold text-base text-left px-3 py-6">
								<span> {{ $t(`Crud.Additionals`) }} </span>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td colspan="6">
								<vs-divider />
							</td>
						</tr>
						<tr v-for="name in uniquePermisions" :key="name">
							<td class="px-3 py-2">{{ name }}</td>
							<td
								v-for="permiso in orderPersmissions(name)"
								class="px-3 py-2"
								:key="permiso.permission_name"
							>
								<vs-checkbox :title="permiso.description" v-model="permiso.check" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</vx-card>
		<div class="vx-row float-right mt-5 mb-5">
			<div class="vx-col w-full">
				<vs-button
					color="danger"
					type="border"
					class="mr-3 mb-2 g-btn--resourcePopup"
					v-if="editable"
					@click.stop="cancelEdit()"
					>{{ $t("Cancel") }}
				</vs-button>
				<vs-button
					id="btn-submit-company"
					class="mb-2 g-btn--resourcePopup"
					color="success"
					:disabled="isFormValid"
					@click="submitForm"
				>
					{{ $t("Save") }}
				</vs-button>
			</div>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";

export default {
	name: "RolesForm",
	components: {
		vSelect,
	},
	props: {
		role: Object,
		editable: Boolean,
	},
	data() {
		return {
			//Permisos seleccionados
			permissionSelected: [],
			// Nombres de los modulos obtenidos de los permisos
			uniquePermisions: [],
			// Listado de todos los permisos del sistema
			permissions: [],
			checkAll: false,
			checkAllC: false,
			checkAllR: false,
			checkAllU: false,
			checkAllD: false,
			currenRole: "editor",
		};
	},
	computed: {
		// Retorna los permisos encontrados en el state
		listPermissions() {
			return this.$store.state.moduleRoles.permissions;
		},
		// Retorna los roles encontrados en el state
		listRoles() {
			return this.$store.state.moduleRoles.roles;
		},
		// Retorna las relaciones Role-Permiso encontrada en el state
		listRolePermission() {
			return this.$store.state.moduleRoles.role_permissions;
		},
		// Deshabilita o habilita el boton submit a partir de la validez de los campos
		isFormValid() {
			return this.errors.any();
		},
		orderPersmissions() {
			return function (name) {
				function compare(a, b) {
					if (a.letter < b.letter) {
						return -1;
					}
					if (a.letter > b.letter) {
						return 1;
					}
					return 0;
				}

				return this.permissions.filter((r) => r.name === name).sort(compare);
			};
		},
	},
	methods: {
		// Abrir load
		openLoading() {
			this.$vs.loading();
		},
		// Cerrar load
		closeLoading() {
			this.$vs.loading.close();
		},
		// Limpiar formulario
		clearForm() {
			this.permissionSelected = [];
			this.$emit("clearRoleEmit");
			this.$validator.reset();
		},
		// Actualizar roles
		updateRolesList() {
			this.$emit("updateRolesEmit");
		},
		validateAllChecked() {
			Array.from(["C", "R", "U", "D"]).forEach((l) => {
				// Buscar si en los permisos de tipo lettra por lo menos hay uno en false de ser asi, no se marca el check de todos
				const per = this.permissions.filter((p) => p.letter === l);
				if (l === "C") this.checkAllC = !per.some((p) => p.check === false);
				if (l === "R") this.checkAllR = !per.some((p) => p.check === false);
				if (l === "U") this.checkAllU = !per.some((p) => p.check === false);
				if (l === "D") this.checkAllD = !per.some((p) => p.check === false);
			});
		},
		// Submit al formulario
		submitForm() {
			this.$validator.validateAll().then((result) => {
				// Si el resultado es falso, los campos no son validos
				if (!result) {
					// Valida los campos para poder visualizar los mensaje de error
					this.$validator.validate();
				} else {
					// Los campos del formulario son correctos
					this.correctRole();
				}
			});
		},
		// Rol correcto
		correctRole() {
			// Creacion del objeto
			let objectFinal = {};
			let arrayFinal = this.getCheckedPermissions();
			// Si el formulario tiene permisos seleccionados
			if (arrayFinal.length > 0) {
				// Inserta los id de los permisos seleccionados en el objeto
				objectFinal.permission_id = arrayFinal;
			} else {
				// Sino envia el campo vacio, de lo contrario no actualizara los permisos
				objectFinal.permission_id = [];
			}
			// Se agrega el nombre del Rol al objeto
			objectFinal.name = this.role.name;
			// Se agrega el nombre del Rol alias al objeto
			objectFinal.alias = this.role.alias;
			// Se agrega la descripción del Rol al objeto
			objectFinal.description = this.role.description;
			// Se abre el Load
			this.openLoading();
			// Se define si se esta editando el rol o se esta modificando, determinado por el prop this.editable
			if (this.editable) {
				// Actualiza Rol - se envia el objeto construido anteriormente al metodo
				this.updateMethod(objectFinal);
			} else {
				// Crea el Rol - se envia el objeto construido anteriormente al metodo
				this.createMethod(objectFinal);
			}
		},
		// Metodo para crear rol
		createMethod(object) {
			// Llama la accion Vuex, "addRole" y envia el objeto
			this.$store
				.dispatch("moduleRoles/addRole", JSON.stringify(object))
				.then((res) => {
					// Respuesta exitosa
					// Cierra el load
					this.closeLoading();
					// Limpia el formulario
					this.clearForm();
					// Actualiza la los roles
					this.updateRolesList();
					this.cancelEdit();
					// Muestra mensaje de exito
					this.$vs.notify({
						color: "success",
						title: this.$t("Roles.Create.Title"),
						text: this.$t("Roles.Create.Text"),
					});
				})
				.catch((err) => {
					// Respuesta erronea
					// Cierra el load
					this.closeLoading();
					// Muestra un mensaje de error
					this.$vs.notify({
						color: "danger",
						title: this.$t("Roles.Create.TitleError"),
						text: this.$t("Roles.Create.TextError"),
					});
					throw new Error(err);
				});
		},
		// Metodo que actualiza el rol
		updateMethod(object) {
			// inserta el id en el objeto para utilizarlo en la url del PUT
			object.id = this.role.id;
			// Llama la acción Vuex "updateRole" y envia el objeto
			this.$store
				.dispatch("moduleRoles/updateRole", object)
				.then((res) => {
					// Respuesta exitosa
					// cierra el load
					this.closeLoading();
					// limpia el formulario
					this.clearForm();
					// Cancela la edición
					this.cancelEdit();
					// Actualiza los roles
					this.updateRolesList();
					// Muestra mensaje de exito
					this.$vs.notify({
						color: "success",
						title: this.$t("Roles.Update.Title"),
						text: this.$t("Roles.Update.Text"),
					});
				})
				.catch((err) => {
					// Respuesta errornea
					// Cierra lod
					this.closeLoading();
					// Muestra mensaje de error
					this.$vs.notify({
						color: "danger",
						title: this.$t("Roles.Update.TitleError"),
						text: this.$t("Roles.Update.TextError"),
					});
					throw new Error(err);
				});
		},
		// Cancela edición en curso
		cancelEdit() {
			// Limpia el formulario
			this.clearForm();
			// Emite la accion cancelar al componente padre "Roles.vue"
			this.$emit("cancelEditEmit");
		},
		// Metodo para renombrar propiedades de un objeto (Se utiliza más adelante)
		renameProperty(obj, oldName, newName) {
			obj[newName] = obj[oldName];
			delete obj[oldName];
			//obj[newName] = ''
			return obj;
		},
		consultPermissions() {
			// Abre el load
			this.openLoading();
			// Actualiza los permisos los permisos
			this.$store
				.dispatch("moduleRoles/getPermissions")
				.then((res) => {
					this.formatPermissions();
					setTimeout(() => {
						this.validateAllChecked();
					}, 200);
					this.closeLoading();
					return res;
				})
				.catch((err) => {
					this.closeLoading();
					this.$vs.notify({
						color: "danger",
						title: this.$t("Roles.Permissions.TitleConsultPermissionsError"),
						text: this.$t("Roles.Permissions.TextConsultPermissionsError"),
					});

					throw new Error(err);
				});
		},
		changeCheckAll(permiso) {
			switch (permiso) {
				case "C":
					this.changeCheckAllC();
					break;
				case "R":
					this.changeCheckAllR();
					break;
				case "U":
					this.changeCheckAllU();
					break;
				case "D":
					this.changeCheckAllD();
					break;
				default:
					break;
			}
		},
		changeCheckAllC() {
			const filter = this.permissions.filter(({letter}) => letter === "C");
			filter.forEach((per) => {
				const perIndex = this.permissions.findIndex((p) => p.id === per.id);
				Object.assign(this.permissions[perIndex], {check: this.checkAllC});
			});
		},
		changeCheckAllR() {
			const filter = this.permissions.filter(({letter}) => letter === "R");
			filter.forEach((per) => {
				const perIndex = this.permissions.findIndex((p) => p.id === per.id);
				Object.assign(this.permissions[perIndex], {check: this.checkAllR});
			});
		},
		changeCheckAllU() {
			const filter = this.permissions.filter(({letter}) => letter === "U");
			filter.forEach((per) => {
				const perIndex = this.permissions.findIndex((p) => p.id === per.id);
				Object.assign(this.permissions[perIndex], {check: this.checkAllU});
			});
		},
		changeCheckAllD() {
			const filter = this.permissions.filter(({letter}) => letter === "D");
			filter.forEach((per) => {
				const perIndex = this.permissions.findIndex((p) => p.id === per.id);
				Object.assign(this.permissions[perIndex], {check: this.checkAllD});
			});
		},
		getCheckedPermissions() {
			const checkedPer = this.permissions.filter((p) => p.check).map((p) => p.id);
			return checkedPer;
		},

		formatPermissions() {
			this.listPermissions.forEach((element) => {
				let splitName = element.name.split("_");
				let name = splitName.length === 3 ? `${splitName[0]}_${splitName[1]}` : splitName[0];
				let letter = splitName.length === 3 ? splitName[2] : splitName[1];
				let id = element.id;
				let permission_name = element.name;
				let description = element.description;
				let check = false;
				this.permissions.push({
					name,
					permission_name,
					letter,
					id,
					check,
					description,
				});
			});
			this.uniquePermisions = [...new Set(this.permissions.map(({name}) => name))];

			if (this.editable) {
				this.setCheckPermissions();
			}
		},
		setCheckPermissions() {
			this.permissionSelected.forEach((permissionSelected) => {
				const perIndex = this.permissions.findIndex((p) => p.id === permissionSelected.id);
				if (perIndex === -1) {
				} else {
					Object.assign(this.permissions[perIndex], {check: true});
				}
			});
		},
	},
	created() {
		this.currenRole = this.$store.state.AppActiveUser.userRole;
		this.consultPermissions();
		if (this.editable) {
			//this.updateRolesList()
			let rolePermissionsValid = [];
			// Recorre las relaciones rol-permiso del state
			Object.values(this.listRolePermission).forEach((val2) => {
				// Si el role_id de la relacion corresponde corresponde al id del rol seleccionado
				if (val2.role_id == this.role.id) {
					rolePermissionsValid.push({...val2});
				}
			});
			let cont = 0;
			// Para que el multi-select funcione correctamente debe tener los valores llave que utiliza la consulta de los permisos
			Object.keys(rolePermissionsValid).forEach((key) => {
				this.renameProperty(rolePermissionsValid[cont], "permission_name", "name");
				this.renameProperty(rolePermissionsValid[cont], "permission_id", "id");
				cont++;
			});
			// Al tener el arreglo de permisos seleccionados se le asigna al options del multi-select, el cual selecciona los permisos
			this.permissionSelected = rolePermissionsValid;
		}
	},
};
</script>
<style lang="scss" scoped>
.tableFixHead {
	overflow: auto;
	height: 300px;
}

.tableFixHead thead th {
	position: sticky;
	top: 0;
	z-index: 1;
	background: #ffffff;
}
</style>
